import { Button, Container, Grid, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import BoxReferral from "./Component/BoxReferral";
import { GetReferralList } from "store/api/referral";
import Header from "./Component/Header";
import Introducing from "./Component/Introducing";
import TableReferral from "./Component/TableReferral";
import TableSkeleton from "components/Skeletons/Table.skeleton";
import UsersStatistic from "./Component/UsersStatistic";
import WrapCode from "./Component/WrapCode";
import http from "config/http";
import useIsMobileView from "hooks/useIsMobileView";
import useNotify from "hooks/useNotify";
import { useSearchParams } from "react-router-dom";
import { Down, Up } from "assets/Icon";

function Referral() {
  const notify = useNotify();
  const theme = useTheme();

  const isMobileView = useIsMobileView();

  const [searchParams] = useSearchParams();
  const pageNumber = searchParams.get("page") || 1;
  const pageSize = searchParams.get("perPage") || 5;

  const [loading, setLoading] = useState(false);
  const [allReferral, setAllReferral] = useState();
  const [seeMore, setSeeMore] = useState(false);

  const getReferralList = async ({ pageSize, pageNumber }) => {
    try {
      setLoading(true);
      const { data } = await http.get(
        GetReferralList({ pageSize, pageNumber })
      );
      setAllReferral(data);
      setLoading(false);
    } catch (error) {
      notify(error?.response?.data?.message, "error");
    }
  };

  const handleShowMoreOrLess = async (state) => {
    await getReferralList({
      pageSize: state ? allReferral?.totalRecords : 5,
      pageNumber: 1,
    });

    setSeeMore((v) => !v);
  };

  useEffect(() => {
    getReferralList({ pageSize, pageNumber });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container maxWidth="100%">
      <Grid container spacing={2}>
        <Header />

        <UsersStatistic />

        <WrapCode
          getAllReferrals={() => getReferralList({ pageSize, pageNumber })}
        />

        <Grid item xs={12} pb={3}>
          {isMobileView ? (
            <>
              {allReferral?.data?.map((referral) => (
                <BoxReferral referral={referral} />
              ))}

              <Grid item xs={12} display="flex" justifyContent="center">
                <Button
                  variant="text"
                  color="secondary"
                  onClick={() => handleShowMoreOrLess(!seeMore)}
                >
                  {seeMore ? "Show Less" : "Show More"}
                  {seeMore ? (
                    <Up color={theme.palette.secondary.main} />
                  ) : (
                    <Down color={theme.palette.secondary.main} />
                  )}
                </Button>
              </Grid>
            </>
          ) : (
            <>
              {!loading ? (
                <TableReferral
                  allReferral={allReferral}
                  getReferralList={getReferralList}
                />
              ) : (
                <TableSkeleton />
              )}
            </>
          )}
        </Grid>

        <Introducing />
      </Grid>
    </Container>
  );
}

export default Referral;
